import DashboardLayout from "components/layouts/dashboard-layout";
import React from "react";
import Default from "./components/default";

const DashboardPromotion = () => {
  return (
    <DashboardLayout>
      <>
        <Default />
      </>
    </DashboardLayout>
  );
};

export default DashboardPromotion;
